import { useEffect, useState } from 'react';
import { useService } from '../ServiceContext';
import { useResoMedia } from '../../components/edit/media/hooks/useResoMedia';
import { useFeatureFlags } from '../FeatureFlagsContext';
import { FeatureFlags } from '../../flags';

export const useResoMediaHandler = (listingKey: string) => {
  const { registerResoMediaErrorHandler } = useService();
  const { hasFeature } = useFeatureFlags();

  const isResoMediaHandlingEnabled = hasFeature(
    FeatureFlags.NGW_MEDIA_FAILURE_MODAL,
  );

  const [showResoMediaDialog, setShowResoMediaDialog] = useState(false);

  const { fetchResoMedia, isFetching } = useResoMedia({
    listingKey,
    onFetchComplete: () => {
      setShowResoMediaDialog(false);
    },
    onFetchError: (error) => {
      console.error(
        'Failed to fetch RESO media from useResoMediaHandler:',
        error,
      );
    },
  });

  // Register handler with ServiceContext only if feature is enabled
  useEffect(() => {
    if (isResoMediaHandlingEnabled) {
      registerResoMediaErrorHandler?.((error: Error) => {
        console.error('RESO media error from saveListing:', error);
        setShowResoMediaDialog(true);
      });
    }
  }, [registerResoMediaErrorHandler, isResoMediaHandlingEnabled]);

  return {
    showResoMediaDialog,
    setShowResoMediaDialog,
    fetchResoMedia,
    isFetching,
    isResoMediaHandlingEnabled,
  };
};
